/**
 * @typedef {object} MessageOptions
 * @property {string} message
 * @property {'success'|'error'} messageType
 * @property {string|HTMLElement} mountOn
 * @property {number} timeout - if 0 then the message will not hide
 */

import { $Q } from '../utils/querySelector';

/**
 *
 * @param {MessageOptions} options
 */
export const createMessage = (options) => {
  const messageContainer = document.createElement('div');
  const messageParagraph = document.createElement('p');

  messageContainer.classList.add('message');
  messageContainer.classList.add(options.messageType);

  messageParagraph.appendChild(document.createTextNode(options.message));

  messageContainer.appendChild(messageParagraph);

  const parentElement =
    typeof options.mountOn === 'string' ? $Q(options.mountOn) : options.mountOn;

  parentElement.innerHTML = '';
  parentElement.appendChild(messageContainer);

  if (options.timeout && options.timeout > 0) {
    const timeoutRef = setTimeout(() => {
      messageContainer.remove();
      clearTimeout(timeoutRef);
    }, options.timeout);
  }
};
